import React from 'react';

export function PrivacyViewer() {
  const data = require('../../../assets/lang/components/privacyPolicy.json');

  return (
    <section className="privacy-policy">
      <div className="privacy-policy__inner">
        <div className="privacy-policy__hero">
          <p className="privacy-policy__eyebrow">{data.hero.eyebrow}</p>
          <h1>{data.hero.title}</h1>
          <p className="privacy-policy__lede">{data.hero.lede}</p>
        </div>

        <div className="privacy-policy__grid">
          {data.sections.map((section) => (
            <article className="privacy-policy__card" key={section.title}>
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </article>
          ))}
        </div>

        <div className="privacy-policy__panel privacy-policy__panel--notice">
          <h2>{data.notice.title}</h2>
          <p>{data.notice.body}</p>
        </div>
      </div>
    </section>
  );
}
